module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/BattleRoomsWrapper/images/header-sparks.9423f500.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/BattleRoomsWrapper/images/header-sparks.png
// module id = 2736
// module chunks = 11